/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';
import store from '../stores/redux-store';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

let isWebSocketConnected = false;
let statusModel = {
    MemoryUsage: 0,
    CpuUsage: 0,
    LinuxCpuUsage: 0,
    LinuxMemoryUsage: 0,
    Group: 0,
    Sent: 0,
    Pending: 0,
    Aquis: 0,
    RunningStatus: '',
    LinuxRunningStatus: '',
    Uptime: ''
};

let systemMessages = [];
let queues = [];
let dashBoardSocket;

const checkAuthorization = () => fetch(`/api/dashboard/1`, options)
const DashboardServices = {
    checkAuthorization: checkAuthorization,
    initWebSockets: () => {
        if(!isWebSocketConnected){
            let url = `ws://${window.location.hostname}/api/dashboard`;
            dashBoardSocket = new WebSocket(url);

            dashBoardSocket.onopen = function () {
                isWebSocketConnected = true;
                console.log("connected");
            };

            dashBoardSocket.onmessage = function (e) {
                let command = JSON.parse(e.data);

                if (command.type === "serverStatus") {
                    let newStatus = Object.assign(statusModel, command.data);
                    store.dispatch({type: 'WP_WIN_SERVER_STATUS', payload: newStatus});

                    if (command.data.Messages) {
                        let messagesReverse = command.data.Messages;

                        for (let i = messagesReverse.length - 1; i > -1; i--) {
                            let logMsg = messagesReverse[i];

                            if (systemMessages.indexOf(logMsg) < 0) {
                                systemMessages.splice(0, 0, logMsg);
                            }

                            if(systemMessages.length > 1000){
                                systemMessages.pop();
                            }
                        }

                        if(messagesReverse.length > 0){
                            store.dispatch({type: 'WP_MESSAGES', payload: systemMessages});
                        }
                    }
                } else if (command.type === "linuxServerStatus") {
                    let newStatus = Object.assign(statusModel, command.data);
                    store.dispatch({type: 'WP_LINUX_SERVER_STATUS', payload: newStatus});
                } else if (command.type === "queues") {
                    queues = command.data;
                    store.dispatch({type: 'WP_QUEUES', payload: queues});
                }
            };

            dashBoardSocket.onclose = function (event) {
                isWebSocketConnected = false;
                let reason;
                let code = event.code;
                // See http://tools.ietf.org/html/rfc6455#section-7.4.1
                if (code == 1000)
                    reason = "Normal closure, meaning that the purpose for which the connection was established has been fulfilled.";
                else if(code == 1001)
                    reason = "An endpoint is \"going away\", such as a server going down or a browser having navigated away from a page.";
                else if(code == 1002)
                    reason = "An endpoint is terminating the connection due to a protocol error";
                else if(code == 1003)
                    reason = "An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message).";
                else if(code == 1004)
                    reason = "Reserved. The specific meaning might be defined in the future.";
                else if(code == 1005)
                    reason = "No status code was actually present.";
                else if(code == 1006)
                    reason = "The connection was closed abnormally, e.g., without sending or receiving a Close control frame";
                else if(code == 1007)
                    reason = "An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).";
                else if(code == 1008)
                    reason = "An endpoint is terminating the connection because it has received a message that \"violates its policy\". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.";
                else if(code == 1009)
                    reason = "An endpoint is terminating the connection because it has received a message that is too big for it to process.";
                else if(code == 1010) // Note that this status code is not used by the server, because it can fail the WebSocket handshake instead.
                    reason = "An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake. <br /> Specifically, the extensions that are needed are: " + event.reason;
                else if(code == 1011)
                    reason = "A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.";
                else if(code == 1015)
                    reason = "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).";
                else
                    reason = "Unknown reason";

                console.log(`ws close reason: ${reason}`);
                store.dispatch({type: 'AUTHORIZATION_CHECKED', payload: checkAuthorization()});
            };
        }
    },
    getCurrentQueues: () => queues,
    runQueueAction: (data) => fetch(`/api/dashboard/queueaction`, Object.assign({}, options, {
        method: 'PUT',
        body: JSON.stringify(data)
    })),
    saveQueue: (data) => fetch(`/api/dashboard/2`, Object.assign({}, options, {
        method: 'POST',
        body: JSON.stringify(data)
    })),
    closeWebSocket: () => {
        if(dashBoardSocket) {
            dashBoardSocket.close();
        }
    }
};

export default {
    DashboardServices
};